import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cache = {};
const load = (key, url, pick = (d) => d) => {
  if (!cache[key]) cache[key] = api.get(url).then((r) => pick(r.data)).catch((e) => { delete cache[key]; throw e; });
  return cache[key];
};

export const invalidateContacts = () => { delete cache.contacts; };

const listeners = new Set();
export const invalidateCatalogs = () => { delete cache.catalogs; listeners.forEach((fn) => fn()); };

const useLoaded = (key, url, pick, enabled = true) => {
  const [data, setData] = useState(null);
  const [version, setVersion] = useState(0);
  useEffect(() => {
    const bump = () => setVersion((v) => v + 1);
    listeners.add(bump);
    return () => listeners.delete(bump);
  }, []);
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    load(key, url, pick).then((d) => alive && setData(d)).catch(() => {});
    return () => { alive = false; };
  }, [key, url, pick, enabled, version]);
  return data;
};

const pickItems = (d) => d.items;
export const useCatalogs = () => useLoaded("catalogs", "/catalogs") || {};
export const useUsers = (enabled = true) => useLoaded("users", "/users", undefined, enabled) || [];
export const useContactOptions = (enabled = true) => useLoaded("contacts", "/contacts", pickItems, enabled) || [];

export const catalogMap = (cats, kind) => Object.fromEntries((cats[kind] || []).map((i) => [i.key, i.label]));
